<div class="invite-tree">
  @for (section of viewSections(); track section.id) {
    <div class="invite-tree-section">
      <div class="invite-tree-section-header">
        <button
          type="button"
          class="invite-tree-chevron-button"
          [attr.aria-expanded]="section.isExpanded"
          [attr.aria-label]="(section.isExpanded ? 'Collapse ' : 'Expand ') + section.name"
          dataSelector="cxp-crl-invite-tree-section-toggle"
          (click)="onSectionExpandToggled(section.id)"
        >
          <aiwyn-icon
            name="chevron-right"
            class="invite-tree-chevron"
            [class.invite-tree-chevron-expanded]="section.isExpanded"
            [height]="16"
            [width]="16"
          />
        </button>

        <mat-checkbox
          class="invite-tree-checkbox mat-checkbox-align-checkbox-top"
          [checked]="section.isChecked"
          [indeterminate]="section.isIndeterminate"
          [disabled]="section.isDisabled"
          [dataSelector]="'cxp-crl-invite-tree-section-checkbox-' + section.id"
          (change)="onSectionToggled(section)"
        >
          <span class="invite-tree-section-name">{{ section.identifier }}. {{ section.name }}</span>
        </mat-checkbox>
      </div>

      @if (section.isExpanded) {
        <ul class="invite-tree-rows">
          @for (row of section.rows; track row.id) {
            <!-- The tooltip lives on the row: a disabled checkbox emits no mouse events of its own. -->
            <li class="invite-tree-row" [attr.data-row-id]="row.id" [tooltip]="row.disabledReason ?? ''" [tooltipEnabled]="row.isDisabled">
              <mat-checkbox
                class="invite-tree-checkbox mat-checkbox-align-checkbox-top"
                [aria-describedby]="row.reasonId"
                [checked]="row.isChecked"
                [disabled]="row.isDisabled"
                [dataSelector]="'cxp-crl-invite-tree-item-checkbox-' + row.id"
                (change)="onRowToggled(row)"
              >
                <span class="invite-tree-row-name">
                  <span class="invite-tree-row-ordinal">{{ row.displayNumber }}</span>
                  {{ row.name }}
                </span>
              </mat-checkbox>

              <!-- One element, two jobs: the checkbox's description, and — where there is no hover — the visible reason. -->
              @if (row.reasonId; as reasonId) {
                <span class="invite-tree-row-reason" [id]="reasonId">{{ row.disabledReason }}</span>
              }
            </li>
          }
        </ul>
      }
    </div>
  } @empty {
    <span class="invite-tree-empty">There are no items to share yet.</span>
  }
</div>
